import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

export const startChat = async (name) => {
  const res = await axios.post(`${API}/chat/start`, { name });
  return res.data;
};

export const fetchSession = async (sid) => {
  const res = await axios.get(`${API}/chat/session/${sid}`);
  return res.data;
};

export const sendMessage = async (sid, sender, text) => {
  const res = await axios.post(`${API}/chat/session/${sid}/message`, { sender, text });
  return res.data;
};

export const listSessions = async () => {
  const res = await axios.get(`${API}/chat/sessions`);
  return res.data;
};

export const endSession = async (sid) => {
  const res = await axios.post(`${API}/chat/session/${sid}/end`);
  return res.data;
};

export const wipeAllSessions = async () => {
  const res = await axios.delete(`${API}/chat/sessions`);
  return res.data;
};
